import React from "react";

import { Label } from "..";
import { LabelFieldProps } from "./type";

export const LabelField: React.FC<LabelFieldProps> = ({
  children,
  required,
  label,
  error,
  onlyFragment = false,
  labelSize = "md",
  tooltip,
}) => {
  const ui = () => (
    <>
      <Label required={required} fontSize={labelSize} tooltip={tooltip}>
        {label}
      </Label>
      {children}
      <span className="text-ui-error block h-5">{error}</span>
    </>
  );

  if (onlyFragment) {
    return ui();
  }

  return <div className={"w-full flex-1"}>{ui()}</div>;
};
